import React from 'react'

export const Events = ({ eventsHeadline, events, marginBottom }) => {
  const pb = `pb-${marginBottom}`
  return (
    <section className={`pt-10 sm:pt-16 ${pb}`}>
      <div className="container relative z-20 text-left">
        <div className="bg-white shadow-md">
          <div className="p-8 mx-auto sm:p-12 md:p-16">
            <h2 className="font-sans text-4xl font-bold leading-tight tracking-wider uppercase text-brand-red sm:text-5xl">
              {eventsHeadline}
            </h2>
            {events.map((event, idx) => (
              <article className="mt-12 xl:mt-16 2xl:mt-20" key={idx}>
                <h3 className="font-sans text-2xl font-medium leading-tight tracking-wide text-gray-500 uppercase sm:text-3xl md:text-4xl">
                  {event.eventTitle}
                </h3>
                <p className="text-xl leading-tight capitalize sm:text-2xl md:text-4xl text-brand-red md:tracking-tight">
                  {event.eventRedText}
                </p>
                {event.eventContent &&
                  event.eventContent.map((deadline, idx) => (
                    <div key={idx}>
                      <h4 className="mt-3 font-bold leading-tight capitalize md:text-xl">
                        {deadline.eventContentBold}
                      </h4>
                      <p className="md:text-xl">
                        {deadline.eventContentContent}
                      </p>
                    </div>
                  ))}
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
